export default ({
  theme, attach, nest, DIALOG
}) => ({
  MuiDialog: {
    root: {}
    // [attach(DIALOG.root)]: {
    //     fontSize: 15,
    //     },
  },
  MuiDialogTitle: {
    root: {
      padding: '4px 16px',
      backgroundColor: theme.palette.primary.teal,
      color: theme.palette.primary.white
    }
  }
});
